import React from 'react';
export function HeroSection() {
  return <section className="py-8 mb-16" data-id="element-85">
      <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-86">
        <div className="md:w-1/2" data-id="element-87">
          <h1 className="text-3xl md:text-4xl font-bold text-emerald-800 mb-4" data-id="element-88">
            I Nearly Gave Up After Decades of Diabetes… Until I Tried This
          </h1>
          <p className="text-lg text-gray-700 mb-6" data-id="element-89">
            After 35 years of stiff toes, blurred vision, weight gain, and
            severe post‑meal blood sugar spikes, I refused to accept my doctor's
            verdict that nothing could be done. Here's how I took control of my
            health.
          </p>
          <p className="text-md italic text-gray-600" data-id="element-90">
            By Martha Lane | Published: August 2025
          </p>
        </div>
        <div className="md:w-1/2 rounded-lg overflow-hidden shadow-md h-72 md:h-80" data-id="element-91">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4JqL7FaWWeEwE7iwTeKpcW/WhatsApp_Image_2025-09-01_at_13.10.51.jpg" alt="Martha Lane, smiling woman with curly grey hair wearing a blue cardigan" className="w-full h-full object-cover object-top" data-id="element-92" />
        </div>
      </div>
      <div className="mt-10 text-gray-700" data-id="element-93">
        <p className="mb-4" data-id="element-94">Dear Reader,</p>
        <p className="mb-4" data-id="element-95">
          If you're reading this, you might be where I was—frustrated,
          exhausted, and feeling like you've tried everything to manage your
          diabetes without seeing real improvement.
        </p>
        <p className="mb-4" data-id="element-96">
          For more than 35 years, I lived with the daily struggle of diabetes.
          The constant monitoring, the medication adjustments, the feeling that
          my body was working against me. My doctor eventually told me that
          after so many years, I should simply "manage expectations" about my
          condition.
        </p>
        <p className="mb-4" data-id="element-97">
          But something in me refused to give up. I started researching,
          experimenting, and documenting everything. What I discovered changed
          everything for me, and it might for you too.
        </p>
      </div>
    </section>;
}